import {
  fontCss,
  mobileFontCss,
  mobileTextCss,
  TextProps,
  textCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

const ForgotPasswordUi = styled.a<TextProps>`
  ${fontCss}
  ${textCss}
  ${p => p.theme.phone} {
    ${mobileFontCss}
    ${mobileTextCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileFontCss}
      ${mobileTextCss}
    `}
`

export default ForgotPasswordUi
